import * as React from 'react';
import {ButtonDeleteContainer} from './ButtonDeleteComponent.style';
import {InputEvent} from '../../types';
import {ConfirmationModal} from '../modal';

type ButtonDeleteComponentProps = {
  onPress: InputEvent;
  hoverColor?: string;
  confirmMessage?: string;
  name?: string;
  title?: string;
}

export const ButtonDeleteComponent = ({onPress, hoverColor, confirmMessage, name, title}:ButtonDeleteComponentProps) : JSX.Element => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const eventRef = React.useRef<React.MouseEvent<HTMLButtonElement>>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    eventRef.current = event;
    setIsModalOpen(true);
  };

  const handleConfirm = () => {
    setIsModalOpen(false);
    if (eventRef.current) {
      onPress(eventRef.current);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <ButtonDeleteContainer
        type="button"
        hoverColor={hoverColor}
        onClick={handleClick}
        title={title}
      />
      <ConfirmationModal
        isOpen={isModalOpen}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        title="Confirmar exclusão"
        message={confirmMessage || `Você tem certeza que deseja apagar este ${name}?`}
        confirmLabel="Apagar"
        cancelLabel="Cancelar"
        variant="danger"
      />
    </>
  );
}